import axios from 'axios';
import type { ApiBaseResponse } from '@hotjar/webapp/domains/common/api';
import type { OnboardingDetails } from './model';
import type { OnboardingResultDto, LocationResultDto } from './dto';
import { mapModelToDto } from './mapper';

export async function onboard(onboardingDetails: OnboardingDetails): Promise<OnboardingResultDto> {
  const response = await axios.post<ApiBaseResponse>(
    '/api/v1/registration/onboard',
    mapModelToDto(onboardingDetails),
  );

  if (!response.data.success) throw new Error('Failed to onboard');

  return response.data;
}

export async function getCountryCode(): Promise<string | undefined> {
  try {
    const response = await axios.get<LocationResultDto>('/api/v1/location');
    return response?.data?.country;
  } catch (error) {
    return undefined;
  }
}
